import Page from './index';
import { authRoles } from 'app/auth';

export default {
settings: {
		layout: {
			config: {
				footer: {
					display: false
				},
			}
		}
	},
	auth: authRoles.agentAndAdmin,
	routes: [
		{
			path: '/archived-assets',
			exact: true,
			component: Page.Layout
		},
		{
			path: '/archived-assets/:id',
			exact: true,
			component: Page.Details
		},
		{
			path: '/archived-assets/:serial_no',
			exact: true,
			component: Page.Layout
		},
	]
};